import * as watcherSagas from './watcherSagas'

export { authReducer, facebookReducer, googleReducer } from './reducers'
export const authWatcherSagas = Object.values(watcherSagas)
export type { AuthState, FacebookUserState, GoogleUserState } from './reducers'
